import React from 'react';
import { flowRight } from 'lodash';
import { type WithTranslation } from '@wix/yoshi-flow-editor';
import { Plus } from '@wix/wix-ui-icons-common/on-stage';
import { Button, ButtonPriority } from '@wix/wix-ui-tpa/cssVars';
import PostLink from '../../../../common/components/link/post-link';
import { connect } from '../../../../common/components/runtime-context';
import withTranslate from '../../../../common/hoc/with-translate';
import { getCreatePostUrl } from '../../../../common/services/get-post-url';
import { getTopology } from '../../../../common/store/topology/topology-selectors';
import { ROUTE_CREATE_POST } from '../../../../post-page/constants/routes';
import { classes } from './create-post-button-mobile.st.css';

/**
 * Same `as`-polymorphism gap as the desktop button.
 *
 * NOTE: this call passes `postSlug`, but PostLink takes `postPath` — so the
 * path never reaches BaseLink and only `postLink` is used. Pre-existing on
 * master; typed as accepted-and-ignored rather than changed here.
 */
const PostLinkButton = Button as unknown as React.ComponentType<
  React.ComponentProps<typeof Button> &
    Omit<React.ComponentProps<typeof PostLink>, 'postPath'> & {
      postPath?: React.ComponentProps<typeof PostLink>['postPath'];
      postSlug?: string;
    }
>;

type Props = ReturnType<typeof mapRuntimeToProps> & Pick<WithTranslation, 't'>;

const CreatePostButtonMobile = ({ t, createPostUrl }: Props) => (
  <PostLinkButton
    as={PostLink}
    postLink={createPostUrl}
    postSlug={ROUTE_CREATE_POST}
    className={classes.root}
    priority={ButtonPriority.secondary}
    prefixIcon={<Plus />}
    fullWidth={true}
    upgrade={true}
    data-hook="create-post-button"
  >
    {t('create-post-button.label')}
  </PostLinkButton>
);

import { type AppState } from '../../../../common/types';

const mapRuntimeToProps = (state: AppState) => ({
  createPostUrl: getCreatePostUrl(getTopology(state)),
});

export default flowRight(withTranslate, connect(mapRuntimeToProps))(CreatePostButtonMobile);
